import { Pipe, inject, type PipeTransform } from '@angular/core';
import { isValidDate } from '../utils/learners.utils';
import { LocalizedDatePipe } from 'src/app/angie-shared/pipes/localized-date/localized-date-pipe.pipe';

@Pipe({
	name: 'dateFormatter',
	standalone: true
})
export class DateFormatterPipe implements PipeTransform {
	datePipe = inject(LocalizedDatePipe);
	transform(value: string): string {
		return isValidDate(value) ? this.datePipe.transform(value, 'mediumDate') : '-';
	}
}
